import React from 'react';
import { Button, type ButtonProps } from 'antd';
import { FileExcelOutlined, FilePdfOutlined } from '@ant-design/icons';
import { theme } from '../../theme';
import './ExportButtons.css';

interface ExportButtonProps extends Omit<ButtonProps, 'icon' | 'children'> {
  disabled?: boolean;
}

export const ExportExcelButton: React.FC<ExportButtonProps> = ({ 
  disabled = false,
  style = {},
  ...restProps 
}) => {
  const iconColor = disabled ? 'rgba(0, 0, 0, 0.25)' : '#ffffff';
  const textColor = disabled ? 'rgba(0, 0, 0, 0.25)' : '#ffffff';
  
  return (
    <Button
      icon={<FileExcelOutlined style={{ color: iconColor }} />}
      disabled={disabled}
      type={disabled ? 'default' : 'primary'}
      size="small"
      style={{
        backgroundColor: disabled ? undefined : theme.colors.success,
        borderColor: disabled ? undefined : theme.colors.success,
        color: textColor,
        fontWeight: 600,
        borderRadius: theme.borderRadius.full,
        ...style
      }}
      className={disabled ? undefined : 'export-excel-button'}
      {...restProps}
    >
      <span style={{ color: textColor }}>Excel</span>
    </Button>
  );
};

export const ExportPDFButton: React.FC<ExportButtonProps> = ({ 
  disabled = false,
  style = {},
  ...restProps 
}) => {
  const iconColor = disabled ? 'rgba(0, 0, 0, 0.25)' : '#ffffff';
  const textColor = disabled ? 'rgba(0, 0, 0, 0.25)' : '#ffffff';
  
  return (
    <Button
      icon={<FilePdfOutlined style={{ color: iconColor }} />}
      disabled={disabled}
      type={disabled ? 'default' : 'primary'}
      size="small"
      style={{
        backgroundColor: disabled ? undefined : theme.colors.primary,
        borderColor: disabled ? undefined : theme.colors.primary,
        color: textColor,
        fontWeight: 600,
        borderRadius: theme.borderRadius.full,
        ...style
      }}
      className={disabled ? undefined : 'export-pdf-button'}
      {...restProps}
    >
      <span style={{ color: textColor }}>PDF</span>
    </Button>
  );
};

